import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";

const baseUrl = process.env.REACT_APP_MARKETER_API_URL;

export const getStorageTrackingApi = createAsyncThunk(
  "storageTracking/getStorageTrackingApi",
  async (systemLoadDate, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/api/storage-tracking`, { Data: systemLoadDate })
      );
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postStorageTrackingApi = createAsyncThunk(
  "storageTracking/postStorageTrackingApi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/api/storage-tracking/save`, { Data: payload })
      );
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStorageTrackingRangeApi = createAsyncThunk(
  "storageTracking/getStorageTrackingRangeApi",
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(fetchWrapper.get(`${baseUrl}/api/storage-tracking/get-range`));
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const saveStorageTrackingRangeApi = createAsyncThunk(
  "storageTracking/saveStorageTrackingRangeApi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/api/storage-tracking/save-range`, { Data: payload })
      );
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
